import React, {useState} from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faGoogle as buttonIcon} from '@fortawesome/free-brands-svg-icons';
import {useDispatch} from 'react-redux';
import {loginUser} from '../../../actions/userActions';
import "./../styles.css";

function LoginEmail(){

  const dispatch = useDispatch();
  const [email, svuser] = useState("pruebita@gmail.com");
  const [password, svpassword] = useState("123");

  const login = () => {
    let data = {
      email,
      password,
      type:"app_email"
    };
    dispatch(loginUser(data));
  }
  
  return(
    <React.Fragment>
      <div className="row m-0 mb-2">
        <div style={{textAlign:"center", fontWeight:"bold"}}>Usuario</div>
        </div>
        <input style={{width:"100%", maxWidth:200}} onChange={(e) => svuser(e.currentTarget.value)} value={email}/>
      <div className="row m-0 mt-2">
        <div style={{textAlign:"center", fontWeight:"bold"}}>Contraseña</div>
        </div>
          <input style={{width:"100%", maxWidth:200}} type="password" onChange={(e) => svpassword(e.currentTarget.value)} value={password}/>
      <div className="row m-0 justify-content-center mt-4 mb-2">
        <div className="bt-1" onClick={login}>INGRESAR</div>
      </div>
    </React.Fragment>
  )
}

export default LoginEmail;
  